import Vue from 'vue'
import { mapState } from 'vuex'
import * as Sentry from '@sentry/vue'
import utils from '@/util'
import cookie from '@/services/cookie'
import config from '@/config'
import office from '@/services/office'

// api
import AuthApi from '@/api/auth'

export default (component) => Vue.component('SSOFormContainer', {
  data() {
    return {
      error: null,
      isSubmitting: false,
    }
  },
  computed: {
    ...mapState({
      isEnableAddinPowerpoint: (state) => state.isEnableAddinPowerpoint,
    }),
  },
  created() {
    const error = utils.getParamValue('error')
    if (error) this.error = 'default_error'
  },
  mounted() {
  },
  destroy() {
  },
  methods: {
    async loginWithSSO(email) {
      try {
        this.isSubmitting = true
        let { redirectUrl } = await AuthApi.loginWithSSO({ email })

        this.checkAudienceRedirect()

        setTimeout(() => {
          this.isSubmitting = false
        }, 2000)
        if (this.isEnableAddinPowerpoint) {
          redirectUrl = `${redirectUrl}?redirectUrl=${config.powerpointCallBack}/pages/token&popup=true`

          window.handleTokenApp = (token) => {
            utils.setCookieToken(token)
            setTimeout(() => {
              this.$router.push('/apps/presentations')
              setTimeout(() => {
                office.handleDataAfterLoadOffice()
              }, 300)
            }, 500)
          }
          window.open(`${redirectUrl}`, 'popupWindow', 'width=800, height=600')
          return
        }
        this.$func.go(redirectUrl)
      } catch (error) {
        Sentry.captureException(error)
        this.isSubmitting = false
        this.error = this.$func.getErrorMessage(error, 'default_error')
      }
    },
    checkAudienceRedirect() {
      const { from, redirect } = this.$route.query

      if (from === 'audience' && redirect) {
        cookie.setValue('audience-sso-login-redirect', redirect, {})
      }
    },
  },
  render(createElement) {
    return createElement(component, {
      props: {
        error: this.error,
        loginWithSSO: this.loginWithSSO,
        isSubmitting: this.isSubmitting,
      },
    })
  },
})
